


























































import {
	computed,
	defineComponent,
	nextTick,
	ref,
	watch,
} from '@vue/composition-api';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import { extractEmbedSrc } from '@front-app/util/video';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';
import HrefInputSection from '../editorSections/HrefInputSection.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		FormSection,
		FormLabel,
		FormInput,
		HelpTooltipBlock,
		HrefInputSection,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const { doMetaInput } = useHighlightsInput(ctx, computed(() => props.value));

		// Video embeds
		const embedCode = ref('');
		const handleEmbedInput = async (newEmbedCode: string) => {
			const srcUrl = extractEmbedSrc(newEmbedCode);
			if (srcUrl) {
				doMetaInput({ href: srcUrl });
				await nextTick();
				embedCode.value = '';
			} else {
				embedCode.value = newEmbedCode;
			}
		};
		watch(embedCode, handleEmbedInput, { immediate: true });
		// END Video embeds

		return {
			doMetaInput,
			embedCode,
		};
	},
});
